import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';
import {EngineCriteria} from './EngineCriteria';
import {EngineExt} from '../message/EngineExt';

export class EngineWrapper extends BaseWrapper<EngineExt, EngineCriteria, BasicScenario>  {}

